/* global Chart, coreui, i18next */

/**
 * --------------------------------------------------------------------------
 * CoreUI PRO Boostrap Admin Template main.js
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

// Disable the on-canvas tooltip

Chart.defaults.pointHitDetectionRadius = 1
Chart.defaults.plugins.tooltip.enabled = false
Chart.defaults.plugins.tooltip.mode = 'index'
Chart.defaults.plugins.tooltip.position = 'nearest'
Chart.defaults.plugins.tooltip.external = coreui.ChartJS.customTooltips
Chart.defaults.defaultFontColor = coreui.Utils.getStyle('--cui-body-color')

document.documentElement.addEventListener('ColorSchemeChange', () => {
  updateCharts()
})

window.addEventListener('DOMContentLoaded', () => {
  updateCharts()
})

i18next.on('languageChanged', () => {
  i18next
    .loadNamespaces('translation')
    .then(() => {
      mainChart.data.labels = [
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 0, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 1, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 2, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 3, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 4, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 5, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 6, 1) })
      ]

      cardChart1.data.labels = [
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 0, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 1, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 2, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 3, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 4, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 5, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 6, 1) })
      ]

      cardChart2.data.labels = [
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 0, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 1, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 2, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 3, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 4, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 5, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 6, 1) })
      ]

      cardChart3.data.labels = [
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 0, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 1, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 2, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 3, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 4, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 5, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 6, 1) })
      ]

      cardChart4.data.labels = [
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 0, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 1, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 2, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 3, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 4, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 5, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 6, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 7, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 8, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 9, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 10, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2023, 11, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2024, 0, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2024, 1, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2024, 2, 1) }),
        i18next.t('dateOnlyMonthName', { date: new Date(2024, 3, 1) })
      ]

      updateCharts()
    })
})

const updateCharts = () => {
  cardChart1.data.datasets[0].pointBackgroundColor = coreui.Utils.getStyle('--cui-primary')
  cardChart2.data.datasets[0].pointBackgroundColor = coreui.Utils.getStyle('--cui-info')
  mainChart.options.scales.x.grid.borderColor = coreui.Utils.getStyle('--cui-border-color-translucent')
  mainChart.options.scales.x.grid.color = coreui.Utils.getStyle('--cui-border-color-translucent')
  mainChart.options.scales.x.ticks.color = coreui.Utils.getStyle('--cui-body-color')
  mainChart.options.scales.y.grid.borderColor = coreui.Utils.getStyle('--cui-border-color-translucent')
  mainChart.options.scales.y.grid.color = coreui.Utils.getStyle('--cui-border-color-translucent')
  mainChart.options.scales.y.ticks.color = coreui.Utils.getStyle('--cui-body-color')

  cardChart1.update()
  cardChart2.update()
  mainChart.update()
}

const random = (min, max) =>
  // eslint-disable-next-line no-mixed-operators
  Math.floor(Math.random() * (max - min + 1) + min)

const cardChart1 = new Chart(document.getElementById('card-chart1'), {
  type: 'line',
  data: {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'My First dataset',
        backgroundColor: 'transparent',
        borderColor: 'rgba(255,255,255,.55)',
        pointBackgroundColor: coreui.Utils.getStyle('--cui-primary'),
        data: [65, 59, 84, 84, 51, 55, 40]
      }
    ]
  },
  options: {
    plugins: {
      legend: {
        display: false
      }
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        border: {
          display: false
        },
        grid: {
          display: false
        },
        ticks: {
          display: false
        }
      },
      y: {
        min: 30,
        max: 89,
        display: false,
        grid: {
          display: false
        },
        ticks: {
          display: false
        }
      }
    },
    elements: {
      line: {
        borderWidth: 1,
        tension: 0.4
      },
      point: {
        radius: 4,
        hitRadius: 10,
        hoverRadius: 4
      }
    }
  }
})

const cardChart2 = new Chart(document.getElementById('card-chart2'), {
  type: 'line',
  data: {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'My First dataset',
        backgroundColor: 'transparent',
        borderColor: 'rgba(255,255,255,.55)',
        pointBackgroundColor: coreui.Utils.getStyle('--cui-info'),
        data: [1, 18, 9, 17, 34, 22, 11]
      }
    ]
  },
  options: {
    plugins: {
      legend: {
        display: false
      }
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        border: {
          display: false
        },
        grid: {
          display: false
        },
        ticks: {
          display: false
        }
      },
      y: {
        min: -9,
        max: 39,
        display: false,
        grid: {
          display: false
        },
        ticks: {
          display: false
        }
      }
    },
    elements: {
      line: {
        borderWidth: 1
      },
      point: {
        radius: 4,
        hitRadius: 10,
        hoverRadius: 4
      }
    }
  }
})

const cardChart3 = new Chart(document.getElementById('card-chart3'), {
  type: 'line',
  data: {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'My First dataset',
        backgroundColor: 'rgba(255,255,255,.2)',
        borderColor: 'rgba(255,255,255,.55)',
        data: [78, 81, 80, 45, 34, 12, 40],
        fill: true
      }
    ]
  },
  options: {
    plugins: {
      legend: {
        display: false
      }
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        display: false
      },
      y: {
        display: false
      }
    },
    elements: {
      line: {
        borderWidth: 2,
        tension: 0.4
      },
      point: {
        radius: 0,
        hitRadius: 10,
        hoverRadius: 4
      }
    }
  }
})

const cardChart4 = new Chart(document.getElementById('card-chart4'), {
  type: 'bar',
  data: {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April'],
    datasets: [
      {
        label: 'My First dataset',
        backgroundColor: 'rgba(255,255,255,.2)',
        borderColor: 'rgba(255,255,255,.55)',
        data: [78, 81, 80, 45, 34, 12, 40, 85, 65, 23, 12, 98, 34, 84, 67, 82],
        barPercentage: 0.6
      }
    ]
  },
  options: {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawTicks: false

        },
        ticks: {
          display: false
        }
      },
      y: {
        border: {
          display: false
        },
        grid: {
          display: false,
          drawTicks: false
        },
        ticks: {
          display: false
        }
      }
    }
  }
})

const mainChart = new Chart(document.getElementById('main-chart'), {
  type: 'line',
  data: {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'My First dataset',
        backgroundColor: `rgba(${coreui.Utils.getStyle('--cui-info-rgb')}, .1)`,
        borderColor: coreui.Utils.getStyle('--cui-info'),
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: [
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200)
        ],
        fill: true
      },
      {
        label: 'My Second dataset',
        borderColor: coreui.Utils.getStyle('--cui-success'),
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: [
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200),
          random(50, 200)
        ]
      }
    ]
  },
  options: {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          color: coreui.Utils.getStyle('--cui-border-color-translucent'),
          drawOnChartArea: false
        },
        ticks: {
          color: coreui.Utils.getStyle('--cui-body-color')
        }
      },
      y: {
        beginAtZero: true,
        border: {
          color: coreui.Utils.getStyle('--cui-border-color-translucent')
        },
        grid: {
          color: coreui.Utils.getStyle('--cui-border-color-translucent')
        },
        max: 250,
        ticks: {
          color: coreui.Utils.getStyle('--cui-body-color'),
          maxTicksLimit: 5,
          stepSize: Math.ceil(250 / 5)
        }
      }
    },
    elements: {
      line: {
        tension: 0.4
      },
      point: {
        radius: 0,
        hitRadius: 10,
        hoverRadius: 4,
        hoverBorderWidth: 3
      }
    }
  }
})
